const CAPACITOR_ERROR_NOT_IMPLEMENTED = 'not implemented';

export const isNotImplementedError = (error: unknown) => {
    return error instanceof Error && error.message.includes(CAPACITOR_ERROR_NOT_IMPLEMENTED);
};
